import { useEffect, useState } from "react";
import { getCafeStatus } from "../../api/cafe.api";

export const BannerBreak = () => {
  const [onBreak, setOnBreak] = useState(false);
  const [windowText, setWindowText] = useState("12:00-12:30");

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const status = await getCafeStatus();
        if (cancelled) return;
        setOnBreak(Boolean(status.baristaOnBreak));
        if (status.breakWindow) {
          setWindowText(`${status.breakWindow.start}-${status.breakWindow.end}`);
        }
      } catch {
        /* ignore — banner is non-critical */
      }
    };
    tick();
    const id = window.setInterval(tick, 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  if (!onBreak) return null;

  return (
    <div className="m-4 rounded-lg bg-yellow-100 border-l-4 border-yellow-500 p-3 flex items-center gap-3">
      <span className="text-xl" aria-hidden>☕️</span>
      <div className="flex-1 text-sm text-yellow-900 font-nunito">
        <div className="font-semibold">บาริสต้าพักช่วง {windowText} น.</div>
        <div className="text-xs opacity-80">
          สั่งได้ปกติ — ออเดอร์จะถูกเตรียมหลังพักจบครับ
        </div>
      </div>
    </div>
  );
};
